

export const loadingReducer = (state = { loading: false, auctionLoading: false, }, action) => {
  switch (action.type) {
    case "SHOW_LOADING":
      return { loading: true };
    case "HIDE_LOADING":
      return { loading: false };
    case "SHOW_AUCTION_LOADING":
      return { loading: true };
    case "SHOW_AUCTION_SUCCESS":
      return { loading: false };
    case "SHOW_AUCTION_FAILED":
      return { loading: false };
      case "SHOW_LOTOUT_LOADING":
        return { loading: true };
      case "SHOW_LOGOUT_SUCCESS":
        return { loading: false };
      case "SHOW_LOGOUT_FAILED":
        return { loading: false };
    default:
      return state;
  }
};
